'use client';

import { useEffect } from 'react';

type Props = {
  // Increment this key each time you want to fire a ripple (e.g. from a
  // form submit handler). Mounting SendRipple by itself is a no-op.
  triggerKey: number;
};

// Single expanding ring across the entire viewport when a Contact submit
// completes successfully + a serif kanji-styled '✓' centered, fading after
// ~2.4s. Pure imperative DOM injection so we don't have to thread state
// through the form's tree.
export function SendRipple({ triggerKey }: Props) {
  useEffect(() => {
    if (triggerKey <= 0) return;
    const ring = document.createElement('div');
    ring.setAttribute('aria-hidden', 'true');
    ring.style.cssText = `
      position: fixed;
      left: 50%; top: 50%;
      width: 40px; height: 40px;
      margin-left: -20px; margin-top: -20px;
      border: 2px solid rgba(212, 165, 116, 0.7);
      border-radius: 50%;
      pointer-events: none;
      z-index: 60;
      animation: zen-pulse 1.4s cubic-bezier(0.16, 1, 0.3, 1) forwards;
    `;
    const check = document.createElement('div');
    check.setAttribute('aria-hidden', 'true');
    check.textContent = '✓';
    check.style.cssText = `
      position: fixed;
      left: 50%; top: 50%;
      transform: translate(-50%, -50%);
      font-size: 64px;
      color: var(--accent);
      font-family: serif;
      pointer-events: none;
      z-index: 60;
      opacity: 0;
      animation: send-check 2.4s cubic-bezier(0.16, 1, 0.3, 1) forwards;
    `;
    document.body.append(ring, check);
    const t = setTimeout(() => {
      ring.remove();
      check.remove();
    }, 2500);
    return () => {
      clearTimeout(t);
      ring.remove();
      check.remove();
    };
  }, [triggerKey]);
  return null;
}
